import { Card } from "@mui/material";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter, useGridApiRef } from "@mui/x-data-grid-pro";
import * as React from "react";
import { useEffect, useState } from "react";
import { getPendingUser } from "../api/user";
import { pendingUsersColumns } from "../columns/pendingUsersColumns";

import { Typography } from "@mui/material";

async function GetPendingUser(user_type, team_number) {
	try {
		// Fetch all matches if no filter is set
		const data = await getPendingUser(user_type, team_number);
		if (!data?.body) throw new Error("Invalid API response");
		return data;
	} catch (error) {
		console.error("Error fetching users:", error);
		return { body: JSON.stringify({ data: [] }) };
	}
}

export default function PendingDataGrid({ user }) {
	const [userData, setUserData] = useState([]);
	const [columns, setColumns] = useState([]);
	const apiRef = useGridApiRef();

	useEffect(() => {
		const fetchData = async () => {
			const result = await GetPendingUser(user?.user_type, user?.team_number);
			try {
				const parsedData = JSON.parse(result?.body);
				setUserData(Array.isArray(parsedData?.data) ? parsedData.data : []);
			} catch (error) {
				console.error("Error parsing user data:", error);
				setUserData([]);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		setColumns(pendingUsersColumns(setUserData) || []);
	}, []);

	function CustomToolbar() {
		return (
			<GridToolbarContainer>
				<GridToolbarQuickFilter />
				<GridToolbarColumnsButton />
				<GridToolbarFilterButton />
			</GridToolbarContainer>
		);
	}

	return (
		<>
			{userData.length > 0 && (
				<DataGridPro
					rows={userData}
					columns={columns}
					sx={{ display: "flex", minHeight: "125px" }}
					apiRef={apiRef}
					pagination
					pageSizeOptions={[5, 10, 25]}
					disableSelectionOnClick
					density="compact"
					editMode="row"
					disableVirtualization
					slots={{
						toolbar: CustomToolbar,
					}}
					getRowId={(row) => row?.user_id ?? ""}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 10,
							},
						},
						pinnedColumns: { right: ["actions"] },
					}}
				/>
			)}
			{userData.length === 0 && (
				<Card sx={{ p: 5 }}>
					<Typography sx={{ textAlign: "center" }}>
						<b>No Pending Users</b>
					</Typography>
				</Card>
			)}
		</>
	);
}
